import React, { Dispatch, SetStateAction } from "react";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";
import Flex from "../../../../../DefaultStyles/Flex";
import RadioBtn from "../../../../../Button/RadioBtn";
import { OptionType } from "../../../../../Filters/DropDown";

interface ServiceInputProps {
  check: {
    hasService: boolean;
    noService: boolean;
  };
  setCheck: Dispatch<
    SetStateAction<{
      public: boolean;
      private: boolean;
      top: boolean;
      normal: boolean;
      hasService: boolean;
      noService: boolean;
    }>
  >;
  isEditMode: boolean;
  resetSubsId: () => void;
  category: OptionType;
}

export default function FaqServiceInput({
  check,
  setCheck,
  isEditMode,
  resetSubsId,
  category,
}: ServiceInputProps) {
  return (
    <FaqDetailRow>
      <FaqDetailLabel>서비스 지정</FaqDetailLabel>

      <Flex gapSize={43}>
        <RadioBtn
          label="지정함"
          noTooltip={true}
          check={check?.hasService}
          clickEvent={() =>
            setCheck((prev) => ({
              ...prev,
              hasService: !prev.hasService,
              noService: false,
            }))
          }
          disabled={!isEditMode}
        />

        <RadioBtn
          label="지정 안 함"
          noTooltip={true}
          check={check?.noService}
          clickEvent={() => {
            setCheck((prev) => ({
              ...prev,
              hasService: false,
              noService: !prev.noService,
            }));
            resetSubsId();
          }}
          disabled={category?.label === "서비스 이용" || !isEditMode}
        />
      </Flex>
    </FaqDetailRow>
  );
}
